// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-4 {
  align-items: center;
  background-color: #5f3595;
  border: 1px none;
  display: flex;
  flex-direction: column;
  
  width: 1440px;
}

.frame-30 {
  align-items: center;
  background-color: var(--gigas);
  border-radius: 44px;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  overflow: hidden;
  padding: 16px 24px;
  position: relative;
  width: 1312px;
}

.concordium-naming-service {
  height: 32px;
  position: relative;
  width: 389.94px;
}

.frame-30-1 {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 24px;
  padding: 0px 0px 8px;
  position: relative;
}

.frame-28 {
  align-items: center;
  background-color: var(--gigas);
  border-radius: 32px;
  display: inline-flex;
  flex: 0 0 auto;
  height: 56px;
  justify-content: center;
  padding: 12px 24px;
  position: relative;
}

.docs {
  color: var(--dark-themetypeprimary);
  font-weight: 700;
  line-height: 24px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.button {
  align-items: flex-start;
  border-radius: 28px;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  height: 64px;
  overflow: hidden;
  padding: 4px;
  position: relative;
}

.bg {
  background-color: var(--ronchi);
  border-radius: 28px;
  height: 64px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.copy-al {
  align-items: center;
  background-color: var(--gigas);
  border-radius: 32px;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  padding: 12px 16px;
  position: relative;
}

.shopcart-outline {
  height: 24px;
  width: 24px;
}

.overlap-group1 {
  margin-top: 48px;
  
  width: 878px;
}

.frame-22 {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 16px;
  left: 4px;
  position: absolute;
  top: 0;
}

.frame-31 {
  align-items: center;
  background-color: #ffffff33;
  border-radius: 40px;
  display: inline-flex;
  flex: 0 0 auto;
  padding: 4px;
  position: relative;
}

.domain-outline {
  height: 64px;
  position: relative;
  width: 64px;
}

.mint-buy-and-sell-ccd-domains {
  color: transparent;
  font-family: var(--font-family-gilroy-bold);
  font-size: var(--font-size-l);
  font-weight: 700;
  letter-spacing: -1.44px;
  position: relative;
  text-align: center;
  width: 870px;
}

.span1 {
  color: var(--ronchi);
}

.secure-your-ccd-dom {
  align-self: stretch;
  color: var(--dark-themetypesecondary);
  font-weight: 700;
  line-height: 42px;
  position: relative;
  text-align: center;
}

.search-suggestions {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  left: 0;
  position: absolute;
  top: 398px;
}

.search-suggestion {
  align-items: flex-start;
  background-color: var(--ronchi);
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-color: var(--gigas-2);
  display: flex;
  flex: 0 0 auto;
  gap: 24px;
  padding: 8px 16px;
  position: relative;
  width: 878px;
}

.thumbnail {
  height: 90px;
  position: relative;
  width: 90px;
}

.frame-39 {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;
  position: relative;
}

.mrtoyccd,
.mrtoysccd,
.mrporterccd {
  align-self: stretch;
  color: var(--gigas);
  font-weight: 700;
  line-height: 36px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
}

.frame-42 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.frame-38 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  position: relative;
}

.fin-vobfi4tx57x-hc-tw-lf-w,
.cj19-aw-euo-qfp2qqn-dva2,
.x5n83kd-y8j-kg-nj-g2-e-jgyk {
  color: var(--gigas);
  font-weight: 700;
  line-height: 32px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.search-suggestion-1 {
  background-color: var(--ronchi);
  border-radius: 0px 0px 18px 18px;
  height: 24px;
  position: relative;
  width: 878px;
}

.frame-34 {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 166px;
  padding: 24px;
  position: relative;
  width: 1312px;
}

.frame-35 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 32px;
  position: relative;
}

.frame-37 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
}

.web23-badge {
  height: 56px;
  position: relative;
  width: 104px;
}

.frame-36 {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  position: relative;
}

.copyright {
  color: var(--dark-themetypesecondary);
  font-weight: 400;
  line-height: 24px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.privacy-policy {
  color: var(--dark-themetypesecondary);
  font-weight: 700;
  line-height: 20px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.social-media {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 24px;
  position: relative;
}

.facebook {
  height: 40px;
  position: relative;
  width: 40px;
}

`, "",{"version":3,"sources":["webpack://./src/css/HomePage4.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;;EAEtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,OAAO;EACP,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".home-page-4 {\n  align-items: center;\n  background-color: #5f3595;\n  border: 1px none;\n  display: flex;\n  flex-direction: column;\n  \n  width: 1440px;\n}\n\n.frame-30 {\n  align-items: center;\n  background-color: var(--gigas);\n  border-radius: 44px;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  overflow: hidden;\n  padding: 16px 24px;\n  position: relative;\n  width: 1312px;\n}\n\n.concordium-naming-service {\n  height: 32px;\n  position: relative;\n  width: 389.94px;\n}\n\n.frame-30-1 {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 24px;\n  padding: 0px 0px 8px;\n  position: relative;\n}\n\n.frame-28 {\n  align-items: center;\n  background-color: var(--gigas);\n  border-radius: 32px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  height: 56px;\n  justify-content: center;\n  padding: 12px 24px;\n  position: relative;\n}\n\n.docs {\n  color: var(--dark-themetypeprimary);\n  font-weight: 700;\n  line-height: 24px;\n  position: relative;\n  text-align: center;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.button {\n  align-items: flex-start;\n  border-radius: 28px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 10px;\n  height: 64px;\n  overflow: hidden;\n  padding: 4px;\n  position: relative;\n}\n\n.bg {\n  background-color: var(--ronchi);\n  border-radius: 28px;\n  height: 64px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.copy-al {\n  align-items: center;\n  background-color: var(--gigas);\n  border-radius: 32px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  justify-content: center;\n  padding: 12px 16px;\n  position: relative;\n}\n\n.shopcart-outline {\n  height: 24px;\n  width: 24px;\n}\n\n.overlap-group1 {\n  margin-top: 48px;\n  \n  width: 878px;\n}\n\n.frame-22 {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 16px;\n  left: 4px;\n  position: absolute;\n  top: 0;\n}\n\n.frame-31 {\n  align-items: center;\n  background-color: #ffffff33;\n  border-radius: 40px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  padding: 4px;\n  position: relative;\n}\n\n.domain-outline {\n  height: 64px;\n  position: relative;\n  width: 64px;\n}\n\n.mint-buy-and-sell-ccd-domains {\n  color: transparent;\n  font-family: var(--font-family-gilroy-bold);\n  font-size: var(--font-size-l);\n  font-weight: 700;\n  letter-spacing: -1.44px;\n  position: relative;\n  text-align: center;\n  width: 870px;\n}\n\n.span1 {\n  color: var(--ronchi);\n}\n\n.secure-your-ccd-dom {\n  align-self: stretch;\n  color: var(--dark-themetypesecondary);\n  font-weight: 700;\n  line-height: 42px;\n  position: relative;\n  text-align: center;\n}\n\n.search-suggestions {\n  align-items: flex-start;\n  display: inline-flex;\n  flex-direction: column;\n  left: 0;\n  position: absolute;\n  top: 398px;\n}\n\n.search-suggestion {\n  align-items: flex-start;\n  background-color: var(--ronchi);\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  border-color: var(--gigas-2);\n  display: flex;\n  flex: 0 0 auto;\n  gap: 24px;\n  padding: 8px 16px;\n  position: relative;\n  width: 878px;\n}\n\n.thumbnail {\n  height: 90px;\n  position: relative;\n  width: 90px;\n}\n\n.frame-39 {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 8px;\n  position: relative;\n}\n\n.mrtoyccd,\n.mrtoysccd,\n.mrporterccd {\n  align-self: stretch;\n  color: var(--gigas);\n  font-weight: 700;\n  line-height: 36px;\n  margin-top: -1.00px;\n  position: relative;\n  white-space: nowrap;\n}\n\n.frame-42 {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n}\n\n.frame-38 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  position: relative;\n}\n\n.fin-vobfi4tx57x-hc-tw-lf-w,\n.cj19-aw-euo-qfp2qqn-dva2,\n.x5n83kd-y8j-kg-nj-g2-e-jgyk {\n  color: var(--gigas);\n  font-weight: 700;\n  line-height: 32px;\n  margin-top: -1.00px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.search-suggestion-1 {\n  background-color: var(--ronchi);\n  border-radius: 0px 0px 18px 18px;\n  height: 24px;\n  position: relative;\n  width: 878px;\n}\n\n.frame-34 {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 166px;\n  padding: 24px;\n  position: relative;\n  width: 1312px;\n}\n\n.frame-35 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 32px;\n  position: relative;\n}\n\n.frame-37 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  position: relative;\n}\n\n.web23-badge {\n  height: 56px;\n  position: relative;\n  width: 104px;\n}\n\n.frame-36 {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 4px;\n  justify-content: center;\n  position: relative;\n}\n\n.copyright {\n  color: var(--dark-themetypesecondary);\n  font-weight: 400;\n  line-height: 24px;\n  margin-top: -1.00px;\n  position: relative;\n  text-align: center;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.privacy-policy {\n  color: var(--dark-themetypesecondary);\n  font-weight: 700;\n  line-height: 20px;\n  position: relative;\n  text-align: center;\n  text-decoration: underline;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.social-media {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 24px;\n  position: relative;\n}\n\n.facebook {\n  height: 40px;\n  position: relative;\n  width: 40px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
